<template>
	<div>

		<h1 class="view-title">
			INTEGRAÇÕES - ACESSOS
		</h1>

		<div class="inner-content shadowed">
			<div class="inner-content-title">
				Lista

				<button class="button-edit access-create-btn" @click="create">
					<i class="fa fa-plus"></i> NOVO
				</button>
			</div>

			<div class="row">
				<div class="col-xs">
					
					<Table 
					:loading="loading"
					:headers="headers" 
					:ordering="ordering" 
					:list="list" 
					:page="page"
					:per_page="0" 
					:total="total" 
					:modifiers="modifiers" 
					v-slot="{item}">

						<button v-if="!item.status" class="button-edit" @click="enable(item.id)" title="Ativar">
							<i class="fa fa-fw fa-check"></i> Ativar
						</button>

						<button v-if="item.status" class="button-edit" @click="disable(item.id)" title="Desativar">
							<i class="fa fa-fw fa-check"></i> Desativar
						</button>

						<button class="button-edit" @click="refresh_token(item.id)" title="Atualizar token">
							<i class="fa fa-fw fa-sync-alt"></i> Atualizar token
						</button>

						<button class="button-remove" @click="remove(item.id)" title="Excluir">
							<i class="fa fa-fw fa-trash"></i> Remover
						</button>

					</Table>

				</div>

			</div>
		</div>

	</div>
</template>

<script>
import Api from "@/lib/Api";

import Table from '@/components/Table';

export default {
	name: "AdminExternalAccess",

	components: { Table },

	data: function() {
		return {
			loading: true,
			list: [],
			page: 0,
			total: 0,
			headers: {
				id: "#",
				name: "Nome",
				token: "Token",
				status: "Status"
			},
			modifiers: {
				status: function(d) {
					if (d) return '<i class="far fa-fw fa-check-square"></i>';
					return '<i class="far fa-fw fa-square"></i>';
				}
			},
			ordering: [],
		};
	},

	mounted: function() {
		this.load();
	},

	activated: function() {
		this.load();
	},

	methods: {
		load: async function() {
			this.list = [];

			let form = {};

			this.loading = true;
			let res = await Api.post_admin("external-access/list", form);
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.list = res.data;
			this.total = this.list.length
		},

		create: async function() {
			const name = await this.$alert.prompt("Insira o nome: ");
			if (!name) return;

			let form = {};
			form.name = name;

			this.list = [];
			this.loading = true;
			let res = await Api.post_admin("external-access/create", form);
			this.loading = false;

			if (res.error) this.$notification.error(res.data);
			this.load();
		},

		remove: async function(id) {
			const confirm = await this.$alert.confirm("Remover o acesso?");
			if (!confirm) return;

			let form = {};
			form.id = id;

			this.list = [];
			this.loading = true;
			let res = await Api.post_admin("external-access/remove", form);
			this.loading = false;

			if (res.error) this.$notification.error(res.data);
			this.load();
		},

		enable: async function(id) {
			const confirm = await this.$alert.confirm("Ativar acesso?");
			if (!confirm) return;

			let form = {};
			form.id = id;

			this.list = [];
			this.loading = true;
			let res = await Api.post_admin("external-access/enable", form);
			this.loading = false;

			if (res.error) this.$notification.error(res.data);
			this.load();
		},

		disable: async function(id) {
			const confirm = await this.$alert.confirm("Desativar acesso?");
			if (!confirm) return;

			let form = {};
			form.id = id;

			this.list = [];
			this.loading = true;
			let res = await Api.post_admin("external-access/disable", form);
			this.loading = false;

			if (res.error) this.$notification.error(res.data);
			this.load();
		},

		refresh_token: async function(id) {
			const confirm = await this.$alert.confirm("Atualizar token?");
			if (!confirm) return;

			let form = {};
			form.id = id;

			this.list = [];
			this.loading = true;
			let res = await Api.post_admin("external-access/refresh-token", form);
			this.loading = false;

			if (res.error) this.$notification.error(res.data);
			this.load();
		}
	}
}
</script>

<style scoped>
.access-create-btn {
	float: right;
	margin-top: 16px;
	margin-left: 15px;
	padding-left: 15px;
	padding-right: 15px;
}
</style>